import {createReducer} from '@reduxjs/toolkit';

import setFootprint from '../actions/set-footprint';

const footprint = createReducer(null, {
  [setFootprint]: (state, {payload}) => payload,
});
export default footprint;
